<template>
  <div style="position:relative;">
    <div class="button-box" v-drag draggable="false">
      <div class="btn-bg-img" @dblclick="openBox">
        <el-tooltip
          effect="dark"
          content="客服旺旺在线时间：周一至周五8：30-18:00，不在线时请留言说明问题，上线后会第一时间回复"
          placement="top-end"
        >
          <!-- <a
            target="_blank"
            href="http://amos.alicdn.com/msg.aw?v=2&amp;uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&amp;site=cntaobao&amp;s=1&amp;charset=utf-8"
            ><img
              border="0"
              src="http://amos.alicdn.com/online.aw?v=2&amp;uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&amp;site=cntaobao&amp;s=1&amp;charset=utf-8"
              alt="点击这里给我发消息"
          /></a> -->
          <a
            target="_blank"
            href="//amos.alicdn.com/msg.aw?v=2&uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&site=cnalichn&s=10&charset=gbk"
            ><img
              border="0"
              src="//amos.alicdn.com/online.aw?v=2&uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&site=cnalichn&s=10&charset=UTF-8"
              alt="点击这里给我发消息"
          /></a>
          <!-- <a
            target="_blank"
            href="//amos.alicdn.com/msg.aw?v=2&uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&site=cnalichn&s=12&charset=gbk"
            ><img
              border="0"
              src="//amos.alicdn.com/online.aw?v=2&uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&site=cnalichn&s=12&charset=UTF-8"
              alt="点击这里给我发消息"
          /></a> -->
        </el-tooltip>

        <!-- <p>
          <el-tooltip
            effect="dark"
            content="提交定制需求和建议"
            placement="top-end"
            ><i class="fa fa-edit" style="font-size:32px"></i>
          </el-tooltip>
        </p> -->
      </div>
      <div class="font-box">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["caseID"],
  data() {
    return {
      text: "客服支持",
      isOpen: false,
      isMove: false
    };
  },
  methods: {
    openBox() {
      console.log("双击");
    },
    mousedowm(e) {
      // 鼠标按下时的鼠标所在的X，Y坐标
      this.mouseDownX = e.pageX;
      this.mouseDownY = e.pageY;
      // 初始位置的X，Y 坐标
      // this.initX = obj.offsetLeft;
      // this.initY = obj.offsetTop;
      console.log("e", e);
      // 表示鼠标已按下
      this.flag = true;
    },
    mousemove(e) {
      if (this.flag) {
        console.log("e :", e);
      }
    }
  },
  directives: {
    drag(el) {
      let oDiv = el; // 当前元素
      // let self = this // 上下文
      // 禁止选择网页上的文字
      document.onselectstart = function() {
        return false;
      };
      oDiv.onmousedown = function(e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        let disX = e.clientX - oDiv.offsetLeft;
        let disY = e.clientY - oDiv.offsetTop;
        document.onmousemove = function(e) {
          // 通过事件委托，计算移动的距离
          let l = e.clientX - disX;
          let t = e.clientY - disY;
          // 移动当前元素
          oDiv.style.left = l + "px";
          oDiv.style.top = t + "px";
        };
        document.onmouseup = function(e) {
          document.onmousemove = null;
          document.onmouseup = null;
        };
        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false;
      };
    }
  }
};
</script>

<style scoped>
.button-box {
  width: 100px;
  /* border-radius: 50%; */
  position: fixed;
  bottom: 40px;
  right: 20px;
  padding-left: 15px;
  padding-top: 8px;
  cursor: pointer;
  opacity: 0.7;
  z-index: 888;
  text-align: center;
}
.btn-bg-img {
  width: 100px;
  /* height: 50px; */
  /* //background-image: url("../../../static/images/click.png"); */
  background-size: cover;
  background-color: #f2f6fc;
  padding-top: 8px;
}
.button-box:hover {
  /* color: white; */
  opacity: 1;
}

.font-box {
  width: 100px;
  font-size: 14px;
  text-align: center;
  background-color: #f2f6fc;
  padding-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Core/FloatIcon.vue